import { apiCall, ApiConfig } from '../../config/api'
import { TypeAsnDocument } from '../../interfaces/Asn/TypeAsnDocument'
import { getTypeAsnDocumentAction } from '../actions/typeAsnDocumentActions'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosError, AxiosResponse } from 'axios'
import { GET_TYPE_ASN_DOCUMENT } from '../types/typeAsnDocumentActionsTypes'
import { DataGridElements } from '../../interfaces/index'

export function* getTypesAsnDocumentAsync() {
  try {
    const { status, data }: AxiosResponse<DataGridElements<TypeAsnDocument>> =
      yield call(apiCall, 'GET', `${ApiConfig.TypeAsnListApi}?pageSize=50`)
    if (status === 200) {
      yield put(getTypeAsnDocumentAction(data.items))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getTypeAsnDocumentAction([], serverError.message))
  }
}

export function* watchGetTypesAsnDocumentAsync() {
  yield takeEvery(GET_TYPE_ASN_DOCUMENT, getTypesAsnDocumentAsync)
}
